export default __webpack_public_path__ + "static/Orthopedic Mattresses for Back Pain-ddc630e5fd5d0db0aec9f9bdb3152977.jpg";